import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import InfoTooltip from './InfoTooltip'; // Ensure this component exists

const ChartCard = ({ title, subtitle, tooltip, children }) => {
  return (
    <Card sx={{ minWidth: 275, boxShadow: 3 }}>
      <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 'bold', ml: 2 }}
          >
            {title}
          </Typography>
          {tooltip && <InfoTooltip title={tooltip} />}
        </Box>
        {subtitle && (
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ ml: 2, mb: 2 }}
          >
            {subtitle}
          </Typography>
        )}
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: '100%', mt: 2 }}>
          {children}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChartCard;
